import { withLazy } from '@/shared/HOC/with-lazy';


export const HeaderLazy = withLazy(() => import('./ui/Header'), 'Header');
